import styles from './productMeasuresDetail.module.css'
import { useMemo } from "react"
import { Product, ProductType } from "../../../state/types"
import { MeasuresTable } from "../../../../common"
import { useUnitTypeLoaders } from "../../../../stock"

type Props = {
  product: Product
}

export const ProductMeasuresDetail = (props: Props) => {
  const { product } = props
  const { type, unitTypeId, measures, unitMeasures } = product

  const unitTypeLoaders = useUnitTypeLoaders()

  const measuresTitle = useMemo(() => {
    const unitType = unitTypeLoaders().findUnitType(unitTypeId)
    return `Medidas ${type === ProductType.BULK && unitType ? 'de 1 ' + unitType.name.toLowerCase() :
      (type === ProductType.PACKAGE ? 'de la caja' : 'del producto')}`
  }, [product])

  return (
    <div className={styles.container}>
      <MeasuresTable
        title={measuresTitle}
        rows={measures}
        space={6}
        readOnly
      />
      {type === ProductType.PACKAGE && unitMeasures && (
        <MeasuresTable
          title='Medidas de 1 unidad'
          rows={unitMeasures}
          space={6}
          readOnly
        />
      )}
    </div>
  )
}
